module.exports = __webpack_public_path__ + "static/sport/btn-login.f500d57.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/btn-login.gif
// module id = U7DW
// module chunks = 0